type AuthEvent = 'signed-out' | 'forbidden' | 'organization-unavailable';
type Listener = (detail?: unknown) => void;

const listeners = new Map<AuthEvent, Set<Listener>>();

/**
 * A tiny event bus so the axios interceptor can tell the router about a dead session
 * without importing React or the router. Keeps the client framework-free, which is what
 * makes it testable without rendering anything.
 */
export const authEvents = {
  on(event: AuthEvent, listener: Listener) {
    const set = listeners.get(event) ?? new Set();
    set.add(listener);
    listeners.set(event, set);
    return () => {
      set.delete(listener);
    };
  },
  emit(event: AuthEvent, detail?: unknown) {
    listeners.get(event)?.forEach((listener) => listener(detail));
  },
  clear() {
    listeners.clear();
  },
};
